export default "__VITE_ASSET__sOSxGx5X__"